import React, { PropsWithChildren } from "react";
import { observer } from "mobx-react";
import Modal from "react-modal";
import { injectFromApp } from "../inject";

interface IModalDialogComponentProps {
    isOpen: boolean;
    className?: string;
    onClose?: () => void;
    closeOnEscape?: boolean;
    closeOnOverlay?: boolean;
}

@injectFromApp<IModalDialogComponentProps>((stores) => ({}))

@observer
export class ModalDialogComponent extends React.Component<PropsWithChildren<IModalDialogComponentProps>> {
    onRequestClose = () => {
        if (this.props.onClose == null) return;
        this.props.onClose();
    };

    render() {
        const { props } = this;
        const { isOpen, children, className, closeOnOverlay, closeOnEscape } = props;
        const appElement = document.getElementById("app-root");

        return (
            <Modal
                isOpen={isOpen}
                appElement={appElement}
                shouldCloseOnOverlayClick={closeOnOverlay ?? true}
                shouldCloseOnEsc={closeOnEscape ?? true}
                onRequestClose={this.onRequestClose}
                className={"modal-dialog " + className}
            >
                {children}
            </Modal>
        );
    }
}
